// <reference types="googlemaps" />
import { Component, OnInit, ViewChild, NgZone, ElementRef, HostListener, Inject, ɵSWITCH_ELEMENT_REF_FACTORY__POST_R3__ } from '@angular/core';
import gql from 'graphql-tag';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';
import { TipoMensaje } from 'src/Wheel.Styles.HighVolume/Mensaje';
import { NotificacionGenerica } from 'src/Wheel.Styles.HighVolume/Notificacion';
import { comuna } from 'src/app/shared/object/comuna.model';
import { region } from 'src/app/shared/object/region.model';
import { territorio } from 'src/app/shared/object/territorio.model';
import { vendedor } from 'src/app/shared/object/vendedor.model';
import { ruta } from 'src/app/shared/object/ruta.model';
import { cliente_proveedor } from 'src/app/shared/object/cliente_proveedor.model';
import { bloqueo_historico } from 'src/app/shared/object/bloqueo_historico.model';
import { vendedor_rubro_cliente } from 'src/app/shared/object/vendedor_rubro_cliente.model';
import { ipt_vendedor_cliente } from 'src/app/shared/object/ipt_vendedor_cliente.model';
import { cliente_vendedor_rubro_IPT } from 'src/app/shared/object/cliente_vendedor_rubro_IPT.model';
import { rubro } from 'src/app/shared/object/rubro.model';
import { canal } from 'src/app/shared/object/canal.model';
import { direccion } from 'src/app/shared/object/direccion.model';
import { maquinaJoin } from 'src/app/shared/object/maquina_join.model';
import { FormGroup, Validators, FormControl, FormBuilder } from '@angular/forms';
import { tipo_cliente } from '../../shared/object/tipo_cliente.model';
import { O_NOFOLLOW } from 'constants';
import { XLS_URL } from '../../../environments/environment';
import { MapsAPILoader, MouseEvent, AgmCoreModule } from '@agm/core';
import { constants } from 'fs';
import { condicion_pago } from 'src/app/shared/object/condicion_pago.model';
import { RutValidator } from 'ng9-rut';
import { RutService } from 'src/app/shared/services/rut.service';
import { ScrollSpyLinkDirective, TabsetComponent, ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { Observable } from 'rxjs';
import { ClienteProveedorService } from 'src/app/services/cliente-proveedor.service';
import { debounceTime, filter } from 'rxjs/operators';
import { MantenedorClientesModalResumenComponent } from './modal-resumen/modal-resumen.component';
import { MantenedorClientesModalDatosComercialesComponent } from './modal-datos-comerciales/modal-datos-comerciales.component';
import { MantenedorClientesModalDatosFinancierosComponent } from './modal-datos-financieros/modal-datos-financieros.component';
import { MantenedorClientesModalDatosPersonalesComponent } from './modal-datos-personales/modal-datos-personales.component';
import { MantenedorClientesModalDireccionesComponent } from './modal-direcciones/modal-direcciones.component';
import { FormDatosFinancierosComponent } from './form-datos-financieros/form-datos-financieros.component';
import { FormDatosComercialesComponent } from './form-datos-comerciales/form-datos-comerciales.component';
import { FormDatosPersonalesComponent } from './form-datos-personales/form-datos-personales.component';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import * as _ from 'lodash';
import { RubroVendedorService } from 'src/app/services/rubro-vendedor.service';
import { log, timeStamp } from 'console';
import { DOCUMENT } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { ClientesService } from '../../services/clientes.service';
import { Subscription } from 'apollo-client/util/Observable';
import { ModalEditProveedorComponent } from './modal-edit-proveedor/modal-edit-proveedor/modal-edit-proveedor.component';
import { EmpresaAlternaSavoryService } from 'src/app/services/empresa_alterna_savory.service';
import { UnidadNegocioService } from 'src/app/services/unidad-negocio.service';
import { unidad_negocio } from 'src/app/shared/object/unidad_negocio.model';
import { ParametroEmpresaService } from 'src/app/services/parametro-empresa.service';
import { RolOperacionService } from 'src/app/services/rol-operacion.service';
import { ModalCargaMasivaComponent } from '../shared/modal-carga-masiva/modal-carga-masiva.component';
// import { CargaMasivaClientesComponent } from './carga-masiva-clientes/carga-masiva-clientes.component';

interface cliente_vendedor_rubro_IPTFixed extends cliente_vendedor_rubro_IPT {
  rubros: any[];
  rubrosVisibles: boolean;
}

declare const google: any;

interface ErrorValidate {
  [s: string]: boolean;
}

@Component({
  selector: 'app-clientes',
  templateUrl: './clientes.component.html',
  styleUrls: ['./clientes.component.scss'],
  providers: [SecurityService, ValidadoresService],
})
export class ClientesComponent implements OnInit {
  private client: GraphQLClient = null;

  @ViewChild(ModalEditProveedorComponent, { static: true }) modalEditarProveedor: ModalEditProveedorComponent;

  @ViewChild(MantenedorClientesModalResumenComponent, { static: true }) modalResumen: MantenedorClientesModalResumenComponent;
  @ViewChild(MantenedorClientesModalDatosComercialesComponent, { static: true }) modalDatosComerciales: MantenedorClientesModalDatosComercialesComponent;
  @ViewChild(MantenedorClientesModalDireccionesComponent, { static: true }) modalEditarDirecciones: MantenedorClientesModalDireccionesComponent;
  @ViewChild(MantenedorClientesModalDatosFinancierosComponent, { static: true }) modalDatosFinancieros: MantenedorClientesModalDatosFinancierosComponent;
  @ViewChild(MantenedorClientesModalDatosPersonalesComponent, { static: true }) editarModalDtoPersonales: MantenedorClientesModalDatosPersonalesComponent;
  @ViewChild(ModalCargaMasivaComponent, { static: true }) cargaMasiva: ModalCargaMasivaComponent;

  @ViewChild(FormDatosPersonalesComponent, { static: true }) formDatosPersonales: FormDatosPersonalesComponent;
  @ViewChild(FormDatosComercialesComponent, { static: true }) formDatosComerciales: FormDatosComercialesComponent;
  @ViewChild(FormDatosFinancierosComponent, { static: true }) formDatosFinancieros: FormDatosFinancierosComponent;

  @ViewChild('datosAgregarPersonales', { static: true }) agregarModal: ModalDirective;

  @ViewChild('staticTabs', { static: true }) staticTabs: TabsetComponent;

  public codigoModulo = 1;
  public rutUsuario = Number(this.accesolocalstorage.getRutUsuario());
  loading: boolean = false;
  public listaComunasFiltro: comuna[];
  public listaRubros: rubro[];
  public listaTerritoriosDireccion: territorio[];
  public listaRutasDireccion: ruta[];
  public listaVendedor: vendedor[];
  public listaRegiones: region[];
  public listaTipoClientes: tipo_cliente[];
  public listaCanales: canal[];
  public listaCliente: cliente_proveedor[] = null;
  public listaBloqueoHistorico: bloqueo_historico[];
  public itemCliente: cliente_proveedor;
  public clienteSeleccionado: cliente_proveedor | any;
  public clienteSeleccionadoData: any;
  public listaDirecciones: direccion[];
  public listaDireccionesCombo: direccion[];
  public itemDireccion: direccion;
  public listaVendedorRubroCliente: vendedor_rubro_cliente[];
  public listaIPTVendedorCliente: ipt_vendedor_cliente[];
  public listaClienteVendedorRubroIPT: cliente_vendedor_rubro_IPT[];
  listaClienteVendedorRubroIPTFixed: cliente_vendedor_rubro_IPTFixed[];

  public listaVendedorRubroClienteAgrega: vendedor_rubro_cliente[];
  public listaIPTVendedorClienteAgrega: ipt_vendedor_cliente[];

  public rutEmpresa: number;
  public sucursalEmpresa: number;
  public rutCliente: number;
  public direccionCliente: number;
  public rutClienteFormateado: string;

  public filtroPrincipalRutCliente: string;
  public filtroPrincipalNombreCliente = '';
  public filtroPrincipalDireccionCliente = '';
  public filtroPrincipalComuna: string;
  public filtroPrincipalEstado: boolean = false;
  public filtroPrincipalEstadoBloqueo = false;
  public filtroxEstado: any;
  public filtroPrincipalVendedor: any;

  public filtroDireccionNombre: string;
  public filtroDireccionDireccion: string;

  public formAgregaDatosPersonales: FormGroup;

  public formDatosDirecciones: FormGroup;
  public formBuscaDatosGrillaPrincipal: FormGroup;

  public paginaActual: number;
  public totalRegistros: number;
  public totalPaginas: number;

  public paginaActualDirecciones: number;
  public totalRegistrosDirecciones: number;
  public totalPaginasDirecciones: number;

  public paginaActualBloqueo: number;
  public totalRegistrosBloqueo: number;
  public totalPaginasBloqueo: number;
  public permiteUnidadNegocio: boolean = false;
  optionsUnidadesDeNegocio: unidad_negocio[] = [];

  // check casa matriz o direccion
  readonly RB_CASAMATRIZ_: boolean = true;
  readonly RB_DIRECCION_ACT: boolean = false;

  public zoom: number = 16;
  public latitude: number;
  public longitude: number;
  private geoCoder;
  public address: string;
  public options = {
    types: ['address'],
  };

  canAddClientesMasivos: boolean;

  @ViewChild('direccionForm', { static: false })
  public searchElementRef: ElementRef;

  // Utils
  private log: any;

  ShowLongLat = false;
  showEmpresaHeredada: boolean = false;
  showButton = false;
  private scrollHeight = 100;
  private PageNum = 1;
  showButtonDown: boolean;
  long: number = 0;
  lat: number = 0;

  //TODO: PINTAR FILA
  HighlightRow: number;
  SelectCliente: any;

  //TODO: VARIABLES PARA SCROLL
  listOfCliente: any;
  currentPayLoad: any;
  totalRegistrosPos: any;
  totalPagPos: any;
  PagPosActual: any;
  notEmptyPost = true;
  notscrolly = true;
  subscription: Subscription;
  HidenEmpresaHeredada: boolean;
  comunaCodigo: number = 0;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    client: GraphQLClient,
    private spinner: NgxSpinnerService,
    private clientesService: ClientesService,
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    public validadores: ValidadoresService,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private fb: FormBuilder,
    private rutValidator: RutValidator,
    public rutService: RutService,
    public toastService: ToastService,
    private messageRendererService: MessageRendererService,
    private clienteProveedorService: ClienteProveedorService,
    private formValidatorsService: FormValidatorsService,
    private rubroVendedorService: RubroVendedorService,
    private empresaAlternaSavoryService: EmpresaAlternaSavoryService,
    private parametroEmpresaService: ParametroEmpresaService,
    private unidadNegocioService: UnidadNegocioService,
    private rolOperacion: RolOperacionService,
  ) {
    this.onScrollTop();
    this.canAddClientesMasivos = false;
    this.log = this.clog.log('MANTENEDOR-CLIENTES');
    this.client = client;

    this.formDatosDirecciones = this.construyeFormAgregaDatosDirecciones();
    this.formBuscaDatosGrillaPrincipal = this.construyeFormBuscaGrillaPrincipal();
    this.paginaActual = 1;
    this.totalPaginas = 1;
    this.totalRegistros = 0;

    this.zoom = 16;

    this.paginaActualDirecciones = 1;
    this.totalPaginasDirecciones = 1;
    this.totalRegistrosDirecciones = 0;

    this.paginaActualBloqueo = 1;
    this.totalPaginasBloqueo = 1;
    this.totalRegistrosBloqueo = 0;
  }

  // optionsProvincia: Array<any> = [];

  optionsRegion: Array<any> = [];
  optionsDatosDireccionAgregarComuna: Array<any> = [];
  optionsEmpresaAlterna: Array<any> = [];

  optionsFiltroComuna: Array<any> = [];

  optionsTerritorioDireccion: Array<any> = [];

  optionsRutaDireccion: Array<any> = [];

  optionsTipoCliente: Array<any> = [];

  optionsCanal: Array<any> = [];

  optionsTipoNegocio: Array<any> = [];

  optionsVendedor: Array<any> = [];

  optionsTipoCobro: Array<any> = [];

  optionsCondicionPago: Array<any> = [];

  optionsListaPrecios: Array<any> = [];
  optionsDireccion: Array<any> = [];
  optionsRubro: Array<any> = [];

  // public checkboxModel: any = { left: true, middle: false };
  public checkboxMatriz: any = { left: true };

  @HostListener('window:scroll')
  onWindowsScroll(): void {
    const yOffSet = window.pageYOffset;
    const scrollTop = this.document.documentElement.scrollTop;

    //* MOSTRAR U OCULTAR BOTONES DE AYUDA SCROLL
    if (this.listOfCliente != null) {
      this.showButton = (yOffSet || scrollTop) > this.scrollHeight;
      this.showButtonDown = (yOffSet || scrollTop) >= 0;
    }
  }

  ngOnInit() {
    this.onScrollTop();

    this.rutEmpresa = this.accesolocalstorage.getRutEmpresa();
    this.sucursalEmpresa = this.accesolocalstorage.getSucursalCodigo();
    // this.optionsTipoCobro = [
    //   { value: '1', label: 'Tipo Cobro 1' },
    //   { value: '2', label: 'Tipo Cobro 2' },
    //   { value: '3', label: 'Tipo Cobro 3' },
    // ];

    // this.optionsCondicionPago = [
    //   { value: '1', label: 'Condicion de pago 1' },
    //   { value: '2', label: 'Condicion de pago 2' },
    //   { value: '3', label: 'Condicion de pago 3' },
    // ];

    // this.optionsListaPrecios = [
    //   { value: '1', label: 'ListaPrecios 1' },
    //   { value: '2', label: 'ListaPrecios 2' },
    //   { value: '3', label: 'ListaPrecios 3' },
    // ];

    this.obtenerDatosVendedores();

    this.obtenerDatosComunas();

    this.obtenerDatosRegion();

    this.obtenerDatosTerritorio();

    this.obtenerDatosRuta();

    this.obtenerDatosTipoCliente();

    this.obtenerCanales();

    this.obtenerDatosModalFinancieros();
    // this.filtraGrillaVistaPrincipal();

    this.loadComboRubros();

    this.formChangesSubscriptions();

    this.loadEmpesaAlterna();

    this.canCargaClienteMasivo();

    // this.obtenerDatosComunasAgregarDireccion();

    // load Places Autocomplete
    this.mapsAPILoader.load().then(() => {
      this.setCurrentLocation();
      const countryRestrict = { country: 'cl' };

      this.geoCoder = new google.maps.Geocoder();

      const autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
        types: ['address'],
        componentRestrictions: countryRestrict,
      });

      // const autocompleteEdita = new google.maps.places.Autocomplete(
      //   this.searchElementRefEdita.nativeElement,
      //   {
      //     types: ['address'],
      //     componentRestrictions: countryRestrict,
      //   }
      // );
      // autocomplete.setFields(['address_component']);

      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          // get the place result
          const place: google.maps.places.PlaceResult = autocomplete.getPlace();
          // verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          // set latitude, longitude and zoom
          this.formDatosDirecciones.get('latitud').setValue(place.geometry.location.lat());
          this.formDatosDirecciones.get('longitud').setValue(place.geometry.location.lng());
          this.formDatosDirecciones.get('direccionFormateada').setValue(place.formatted_address);
          this.formDatosDirecciones.get('direccion').setValue(place.name);
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.zoom = 16;
          this.address = place.formatted_address;
          const comunaId = this.listaComunasFiltro.filter((ele) => ele.nombre === place.address_components[2].long_name.toUpperCase().trim());

          this.formDatosDirecciones.get('comuna').setValue(comunaId[0].codigo);
        });
      });
    });
    this.filtraGrillaVistaPrincipal();
    this.parametroUnidadNegocio();
    this.loadUnidadNegocio();
  }

  ClickedRow(index, detalleCliente) {
    this.HighlightRow = index;
    this.SelectCliente = detalleCliente;
  }

  checkEmpresa({ checked }) {
    this.formDatosDirecciones.get('showEmpresaHeredada').setValue(checked);
  }

  //* LA BARRA DEL SCROLL QUEDA AL INICIO AL INGRESAR A LA VISTA - SCROLL CON BOTON SUBIR
  onScrollTop(): void {
    this.document.documentElement.scrollTop = 0;
  }

  //* SE PUEDE REALIZAR UN SCROLL A TRAVES DEL BOTON BAJAR
  onScrollAbajo(): void {
    this.document.documentElement.scrollBy(0, 1000);
  }

  //* AL REALIZAR EL SCROLL HACIA ABAJO SE AGREGAN LOS SIGUIENTES 100 DATOS DE LA PAGINA SGTE
  onScrollDown(e): void {
    const inputParams = _.cloneDeep(this.currentPayLoad);
    if (inputParams != undefined || inputParams != null) {
      delete inputParams.paginaActual;
      this.PageNum += 1;
      inputParams.paginaActual = this.PageNum;

      this.spinner.show();
      if (this.notscrolly && this.notEmptyPost) {
        self.document.getElementById('spinnerX').style.display = 'block';

        this.clientesService.GetClientesFiltro(inputParams);

        this.clientesService.queryCliente.subscribe((data: any[]) => {
          this.PagPosActual = data[0].obtenerSegunFiltroMaestraCliente.respuesta.paginaActual;
          this.totalPagPos = data[0].obtenerSegunFiltroMaestraCliente.respuesta.totalPaginas;
          this.totalRegistrosPos = data[0].obtenerSegunFiltroMaestraCliente.respuesta.totalRegistros;
          this.listOfCliente.push(...data[0].obtenerSegunFiltroMaestraCliente.respuesta.registros);
          // console.log("Dame los siguientes datos del paginado",this.listOfCliente)
          this.spinner.hide();
          self.document.getElementById('spinnerX').style.display = 'block';

          if (data[0].obtenerSegunFiltroMaestraCliente.respuesta.paginaActual === data[0].obtenerSegunFiltroMaestraCliente.respuesta.totalPaginas) {
            this.notEmptyPost = false;
            self.document.getElementById('spinnerX').style.display = 'none';
          }

          if (data[0].obtenerSegunFiltroMaestraCliente.respuesta.cantidadRegistrosPorPagina < 20) {
            self.document.getElementById('spinnerX').style.display = 'none';
            this.PagPosActual = 1;
          }

          this.notscrolly = true;
        });
      }
    }
  }

  private setCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.formDatosDirecciones.get('latitud').setValue(position.coords.latitude);
        this.formDatosDirecciones.get('longitud').setValue(position.coords.latitude);
        this.zoom = 16;
        this.getAddress(position.coords.latitude, position.coords.longitude);
      });
    }
  }

  ShowCoordenadasLatLong({ checked }) {
    if (checked === true) {
      this.ShowLongLat = true;
      const a = this.formDatosDirecciones.get('direccion').value;
      this.formDatosDirecciones.get('direccNueva').setValue(a);
    } else {
      this.ShowLongLat = false;
      const a = this.formDatosDirecciones.get('direccNueva').value;
      this.formDatosDirecciones.get('direccion').setValue(a);
    }
    // Actualiza los validadores cada vez que cambia showLongLat
    this.toggleValidators();
  }

  toggleValidators(): void {
    if (this.ShowLongLat) {
      this.formDatosDirecciones.get('direccion').clearValidators();
      this.formDatosDirecciones.get('direccNueva').setValidators([Validators.required]);
    } else {
      this.formDatosDirecciones.get('direccion').setValidators([Validators.required]);
      this.formDatosDirecciones.get('direccNueva').clearValidators();
    }
    this.formDatosDirecciones.get('direccion').updateValueAndValidity();
    this.formDatosDirecciones.get('direccNueva').updateValueAndValidity();

    const DireccNueva = this.formDatosDirecciones.get('direccNueva').value;
    const Direcc = this.formDatosDirecciones.get('direccion').value;
    if ((DireccNueva == null || DireccNueva == '') && (Direcc == null || Direcc == '')) {
      this.formDatosDirecciones.get('direccion').clearValidators();
      this.formDatosDirecciones.get('direccNueva').clearValidators();
    }

    this.formDatosDirecciones.get('direccion').updateValueAndValidity();
    this.formDatosDirecciones.get('direccNueva').updateValueAndValidity();
  }

  formChangesSubscriptions() {
    this.formDatosDirecciones
      .get('latitud')
      .valueChanges.pipe(filter(Boolean), debounceTime(1000))
      .subscribe((latitud: number) => {
        this.getAddress(latitud, this.formDatosDirecciones.get('longitud').value);
        this.latitude = latitud;
        this.EnableItem();
      });

    this.formDatosDirecciones
      .get('longitud')
      .valueChanges.pipe(filter(Boolean), debounceTime(1000))
      .subscribe((longitud: number) => {
        this.getAddress(this.formDatosDirecciones.get('latitud').value, longitud);
        this.longitude = longitud;
        this.EnableItem();
      });

    this.formDatosDirecciones
      .get('comuna')
      .valueChanges.pipe(filter(Boolean), debounceTime(1000))
      .subscribe((comuna: number) => {
        // this.getAddress(this.formDatosDirecciones.get("latitud").value, longitud);
        this.comunaCodigo = comuna;
        this.loadEmpesaAlterna();
      });
  }

  // cliente sin datos para visualizarlos en color rojo en la tabla principal de cliente
  hasMissingData(cliente): boolean {
    return (
      cliente.condicion_pago_codigo < 1 ||
      cliente.condicion_pago_codigo == null ||
      cliente.giro == null ||
      cliente.giro == '' ||
      cliente.lista_precio_codigo < 1 ||
      cliente.tipo_cliente_codigo == '' ||
      cliente.tipo_cliente_codigo == null ||
      cliente.codigo_direccion == null ||
      cliente.codigo_direccion == 0 ||
      cliente.direccion_completa == null ||
      cliente.direccion_completa == '' ||
      (cliente.codigo_vendedor == 0 && cliente.es_direccion_despacho == false) ||
      (cliente.codigo_vendedor == null && cliente.es_direccion_despacho == false) ||
      cliente.codigo_comuna == null ||
      cliente.codigo_comuna == 0
    );
  }

  markerDragEnd($event: MouseEvent) {
    this.latitude = $event.coords.lat;
    this.longitude = $event.coords.lng;
    this.formDatosDirecciones.get('latitud').setValue($event.coords.lat);
    this.formDatosDirecciones.get('longitud').setValue($event.coords.lng);
    this.getAddress(this.latitude, this.longitude);
  }

  EnableItem() {
    const lat = this.formDatosDirecciones.get('latitud').value;
    const lng = this.formDatosDirecciones.get('longitud').value;
    this.getLocationPlace(lat, lng);
  }

  lastLocalitationLat: number = 0;
  lastLocalitationLong: number = 0;
  getLocationPlace(latitude: number, longitude: number) {
    this.lat = latitude;
    this.long = longitude;

    if (!latitude || !longitude) return;

    latitude = latitude;
    longitude = longitude;

    if (this.lastLocalitationLat !== latitude && this.lastLocalitationLong !== longitude) {
      this.lastLocalitationLat = latitude;
      this.lastLocalitationLong = longitude;

      this.geoCoder.geocode(
        { location: { lat: Number(this.lastLocalitationLat), lng: Number(this.lastLocalitationLong) } },
        (results, status) => {
          if (status === 'OK') {
            if (results[0]) {
              this.ngZone.run(() => {
                // verify result

                this.zoom = 16;
                this.latitude = Number(this.lastLocalitationLat);
                this.longitude = Number(this.lastLocalitationLong);
                this.address = results[0].formatted_address;
              });
            } else {
              // window.alert(
              //   'No se encontraron resultados. Debe ingresarla manualmente.'
              // );
              this.toastService.info('No se encontraron resultados. Debe ingresarla manualmente.');
            }
          } else {
            // window.alert('Fallo de GeoCoder: ' + status);
            if (status == google.maps.GeocoderStatus.OVER_QUERY_LIMIT) {
              setTimeout(() => 3000);
            }
          }
        }
        // this.log(results);
        // this.log(status);
      );
    }
  }

  // getAddress(latitude, longitude) {
  //   this.geoCoder.geocode({ location: { lat: latitude, lng: longitude } }, (results, status) => {
  //     // this.log(results);
  //     // this.log(status);
  //     if (status === 'OK') {
  //       if (results[0]) {
  //         this.zoom = 16;
  //         this.address = results[0].formatted_address;
  //         this.formDatosDirecciones.get('direccionFormateada').setValue(results[0].formatted_address);
  //         this.formDatosDirecciones.get('direccion').setValue(results[0].formatted_address.split(',')[0]);

  //         const comunaId = this.listaComunasFiltro.filter((ele) => ele.nombre === results[0].address_components[2].long_name.toUpperCase().trim());

  //         this.formDatosDirecciones.get('comuna').setValue(comunaId[0].codigo);
  //       } else {
  //         // window.alert(
  //         //   'No se encontraron resultados. Debe ingresarla manualmente.'
  //         // );
  //         this.toastService.info('No se encontraron resultados. Debe ingresarla manualmente.');
  //       }
  //     } else {
  //       // window.alert('Fallo de GeoCoder: ' + status);
  //       if (status == google.maps.GeocoderStatus.OVER_QUERY_LIMIT) {
  //         setTimeout(() => 3000);
  //       }
  //     }
  //   });
  // }

  getAddress(latitud, longitud): void {
    const lat = Number(latitud);
    const lng = Number(longitud);
    const geocoder = new google.maps.Geocoder();
    const latlng = { lat: lat, lng: lng }; // Corrige las propiedades aquí
    geocoder.geocode({ location: latlng }, (results, status) => {
      if (status === 'OK') {
        if (results[0]) {
          this.zoom = 16;
          this.address = results[0].formatted_address;
          console.log(this.address);
          const addressComponents = results[0].address_components;
          const comuna = this.extractComuna(addressComponents);
          this.formDatosDirecciones.get('direccNueva').setValue(this.address.split(',')[0]);
          console.log(comuna);
          if (latitud != null && longitud != null && this.ShowLongLat == true) {
            const comunaId = this.listaComunasFiltro.filter((ele) => ele.nombre.trim() === comuna.trim());
            this.formDatosDirecciones.get('comuna').setValue(comunaId[0].codigo);
          }
        } else {
          this.toastService.info('No se encontraron resultados. Debe ingresarla manualmente.');
          console.log('No results found');
        }
      } else {
        console.log('Geocoder failed due to: ' + status);
      }
    });
  }

  extractComuna(addressComponents: google.maps.GeocoderAddressComponent[]): string | null {
    for (let component of addressComponents) {
      if (component.types.includes('locality')) {
        return component.long_name.toUpperCase(); // O long_name o short_name dependiendo de lo que necesites
      }
    }
    return null;
  }

  eliminaVendedorRubro(rubroipt: any) {
    const { vendedor_codigo } = rubroipt;
    this.listaClienteVendedorRubroIPT = this.listaClienteVendedorRubroIPT.filter((vendedor) => vendedor.vendedor_codigo !== vendedor_codigo);
    this.setListaVendedoresFixed();
  }

  setCobradorByDefault() {
    if (!this.listaClienteVendedorRubroIPT) return;
    const cobradoresMatches = this.listaClienteVendedorRubroIPT.filter((vendedor) => vendedor.es_cobrador).length;
    if (cobradoresMatches === 0 && this.listaClienteVendedorRubroIPT.length > 0) this.listaClienteVendedorRubroIPT[0].es_cobrador = true;
  }

  agregaVendedorRubro() {
    if (
      this.formDatosDirecciones.get('VendedorSel').value === null //||
      // this.formDatosDirecciones.get("RubroSel").value === null
    ) {
      // alert('Debe escoger vendedor y rubro');
      // this.toastService.warning("Debe escoger vendedor y rubro");
      this.toastService.warning('Debe escoger vendedor');
      return;
    }
    // for (const item of this.listaClienteVendedorRubroIPT) {
    //   const arr = [item.rubro_codigo, item.nombreRubro];
    //   const idx = arr.indexOf(
    //     this.formDatosDirecciones.get("RubroSel").value
    //   );
    //   if (idx !== -1) {
    //     // alert('El rubro ya se encuentra ingresado');
    //     this.toastService.info("El rubro ya se encuentra ingresado");
    //     return;
    //   }
    // }

    this.obtenerRubrosPorVendedor(
      this.formDatosDirecciones.get('VendedorSel').value,
      (respuesta) => {
        this.log('success', respuesta);

        console.log('muestramedsadsa', this.listaClienteVendedorRubroIPT);

        const cobradoresMatches = this.listaClienteVendedorRubroIPT.filter((vendedor) => vendedor.es_cobrador).length;

        let nombreVendedor = '';
        this.listaVendedor.forEach((element) => {
          if (element.codigo === this.formDatosDirecciones.get('VendedorSel').value) {
            nombreVendedor = element.nombre;
          }
        });

        const vendedor_codigo_agregado = Number(this.formDatosDirecciones.get('VendedorSel').value);
        const isNew = this.listaClienteVendedorRubroIPT.findIndex((v: cliente_vendedor_rubro_IPTFixed) => v.vendedor_codigo === vendedor_codigo_agregado) < 0;

        const vendedorRubro = respuesta.filter((r) => r.asignado);
        if (vendedorRubro.length === 0) {
          this.toastService.error('Vendedor no tiene rubros asignados');
          return;
        }
        vendedorRubro.forEach((rubroVendedor) => {
          /** INICIO Agregar uno **/
          const sel: cliente_vendedor_rubro_IPT = {
            cliente_proveedor_rut: this.rutCliente,
            direccion_codigo: this.direccionCliente,
            es_cobrador: cobradoresMatches > 0 ? false : true,
            lunes: false,
            martes: false,
            miercoles: false,
            jueves: false,
            viernes: false,
            sabado: false,
            domingo: false,
            rut_empresa: this.rutEmpresa,
            sucursal_codigo: this.sucursalEmpresa,
            vendedor_codigo: this.formDatosDirecciones.get('VendedorSel').value,
            rubro_codigo: rubroVendedor.rubro_codigo, //this.formDatosDirecciones.get("RubroSel").value,
            realiza_cobro_maquina: false,
            nombreVendedor,
            nombreRubro: rubroVendedor.rubro_nombre,
            unidad_negocio_codigo: [],
          };

          // this.listaRubros.forEach((element) => {
          //   if (
          //     element.codigo === this.formDatosDirecciones.get("RubroSel").value
          //   ) {
          //     sel.nombreRubro = element.descripcion;
          //   }
          // });

          this.listaClienteVendedorRubroIPT.push(sel);
        });
        /** FIN Agregar uno **/

        this.setListaVendedoresFixed();

        if (isNew) {
          this.hideAllRubrosPanel();
          this.listaClienteVendedorRubroIPTFixed[this.listaClienteVendedorRubroIPTFixed.length - 1].rubrosVisibles = true;
        } else {
          const indexVendedorRubrosDisplayed = this.listaClienteVendedorRubroIPTFixed.findIndex((v: cliente_vendedor_rubro_IPTFixed) => v.vendedor_codigo === vendedor_codigo_agregado);
          this.hideAllRubrosPanel();
          this.listaClienteVendedorRubroIPTFixed[indexVendedorRubrosDisplayed].rubrosVisibles = true;
        }
      },
      () => {
        this.log('error');
      }
    );
  }

  obtenerRubrosPorVendedor(vendedor_codigo: number, success: Function, error: Function) {
    const inputParams = {
      entidad: {
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa,
        vendedor_codigo,
      },
    };

    this.log('inputParams', JSON.stringify(inputParams));

    this.rubroVendedorService.obtenerRubrosVendedor(inputParams, ({ respuesta, mensajes }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showErrors(mensajes);
        error();
        return;
      }

      success(respuesta);
    });
  }

  handleChangeCobrador(rubroipt: cliente_vendedor_rubro_IPTFixed) {
    const { vendedor_codigo } = rubroipt;

    // limpiar todos
    this.listaClienteVendedorRubroIPT.forEach((vendedor: cliente_vendedor_rubro_IPT) => {
      vendedor.es_cobrador = false;
    });

    const vendedorSeleccionadoIndex = this.listaClienteVendedorRubroIPT.findIndex((vendedor) => vendedor.vendedor_codigo === vendedor_codigo);
    this.listaClienteVendedorRubroIPT[vendedorSeleccionadoIndex].es_cobrador = true;

    this.setListaVendedoresFixed();
  }

  CambiaIPT(dia: string, rubroipt: any, index: any) {
    const { vendedor_codigo } = rubroipt;
    this.listaClienteVendedorRubroIPT.forEach((vendedor: cliente_vendedor_rubro_IPT) => {
      if (vendedor.vendedor_codigo === vendedor_codigo) {
        // vendedor.es_cobrador = false;
        vendedor[dia] = !vendedor[dia];
      }
    });
    // this.log('dia', dia, 'rubroipt', rubroipt, 'index', index, this.listaClienteVendedorRubroIPT)

    this.setListaVendedoresFixed();
  }

  loadGrillaVendedores() {
    // listaClienteVendedorRubroIPT
    const self = this; // this is unused
    this.log('loadGrillaVendedores');

    const inputParams = {
      rutEmpresa: this.rutEmpresa,
      sucursalCodigo: this.sucursalEmpresa,
      rutCliente: this.rutCliente,
      direccionCodigo: this.direccionCliente,
    };

    this.clientesService.obtenerSegunFiltroRubroeIPT(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      const { registros } = respuesta;

      self.listaClienteVendedorRubroIPT = registros;
      self.setListaVendedoresFixed();
    });
  }

  setListaVendedoresFixed() {
    let listaVendedores = [];
    let lastVendedorCodigo = null;

    const vendedorRubrosVisiblesIndex = this.getVendedorRubrosVisiblesIndex();

    _.orderBy(this.listaClienteVendedorRubroIPT, ['vendedor_codigo'], ['asc']).forEach((vendedor) => {
      // nuevo registro
      if (lastVendedorCodigo !== vendedor.vendedor_codigo) {
        lastVendedorCodigo = vendedor.vendedor_codigo;
        listaVendedores.push(vendedor);
        listaVendedores[listaVendedores.length - 1].rubros = [];
        listaVendedores[listaVendedores.length - 1].rubrosVisibles = false;
        listaVendedores[listaVendedores.length - 1].front_id = `vendedor_${vendedor.vendedor_codigo}`;
      }

      // add rubro al actual (último)
      listaVendedores[listaVendedores.length - 1].rubros.push({ nombreRubro: vendedor.nombreRubro, rubro_codigo: vendedor.rubro_codigo });
    });

    // Set cobrador
    let hasDefaultCobrador = false;
    for (let i = 0; i < this.listaClienteVendedorRubroIPT.length; i++) {
      if (this.listaClienteVendedorRubroIPT[i].es_cobrador) {
        const cobradorIndex: number = listaVendedores.findIndex((vendedor) => vendedor.vendedor_codigo === this.listaClienteVendedorRubroIPT[i].vendedor_codigo);
        listaVendedores[cobradorIndex].es_cobrador = true;
        hasDefaultCobrador = true;
        break;
      }
    }
    this.listaClienteVendedorRubroIPTFixed = listaVendedores;

    if (vendedorRubrosVisiblesIndex >= 0 && this.listaClienteVendedorRubroIPTFixed && this.listaClienteVendedorRubroIPTFixed.length > vendedorRubrosVisiblesIndex) {
      this.listaClienteVendedorRubroIPTFixed[vendedorRubrosVisiblesIndex].rubrosVisibles = true;
    }

    if (!hasDefaultCobrador) this.setCobradorByDefault();
  }

  /***************Construccion de formularios reactivos****************/
  construyeFormBuscaGrillaPrincipal() {
    return new FormGroup({
      filtroPrincipalRutCliente: new FormControl(''),
      filtroPrincipalNombreCliente: new FormControl(''),
      filtroPrincipalDireccionCliente: new FormControl(''),
      filtroPrincipalComuna: new FormControl({ value: '' }),
      filtroPrincipalxEstado: new FormControl(true),
      filtroPrincipalEstadoBloqueo: new FormControl(false),
      filtroPrincipalVendedor: new FormControl(''),
    });
  }

  construyeFormAgregaDatosPersonales() {
    return new FormGroup({
      rutCliente: new FormControl(
        { value: '' },
        [Validators.minLength(7), Validators.maxLength(13), Validators.required, this.validadores.ValidaFormatoRut]
        // this.validaExistenciaUsuario
      ),
      nombreCliente: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(50)]),
      tipoCliente: new FormControl('', [Validators.required]),
      estadoCliente: new FormControl({ value: false, disabled: true }),
      esClienteBloqueado: new FormControl(false),
    });
  }

  formAgregaDatosPersonalesChangesSubscriptions() {
    this.formAgregaDatosPersonales
      .get('rutCliente')
      .valueChanges.pipe(filter(Boolean), debounceTime(1000))
      .subscribe((rutCliente: string) => {
        const rut = this.rutService.QuitarDV(this.rutService.Limpiar(rutCliente));
        this.queryValidaExistenciaUsuario(rut.toString(), ({ registros }) => {
          const matches = registros.filter((cliente) => cliente.rut === rut);
          if (matches.length > 0) {
            const rutClienteFormateado = this.validadores._enmascaraRut(rut.toString());
            this.toastService.error(`El rut ${rutClienteFormateado} ya existe`, 'Atención');
            this.agregarModal.hide();
          }
        });
      });
  }

  queryValidaExistenciaUsuario(rut: string, callback) {
    const inputParams = {
      nombre: '',
      rut,
      busquedaxEstado: 3,
      bloqueado: false,
      es_cliente: true,
      empresa_rut: this.rutEmpresa,
      paginaActual: 1,
      cantidadRegistrosPorPagina: 1,
    };

    this.clienteProveedorService.obtenerSegunFiltroSoloClientes(inputParams, (result) => {
      callback(result);
    });
  }

  // validaExistenciaUsuario(control: FormControl): Promise<ErrorValidate> | Observable<ErrorValidate> {
  //   console.log('1', control.parent)
  //   console.log('2', control.parent.parent)
  //   if (!control.value) {
  //     return Promise.resolve(null);
  //   }

  //   this.queryValidaExistenciaUsuario(control.value)

  //   return new Promise((resolve, reject) => {
  //     setTimeout(() => {
  //       if (control.value === '155721715') {
  //         resolve({ existeUsuario: true });
  //       } else {
  //         resolve(null);
  //       }
  //     }, 1000);
  //   });
  // }

  construyeFormAgregaDatosDirecciones() {
    return new FormGroup({
      showCoordenadas: new FormControl({ value: false }),
      estadoDireccion: new FormControl({ value: true }),
      direccDesp: new FormControl({ value: false }),
      esCasaMatriz: new FormControl({ value: true }),
      region: new FormControl({ value: '' }),
      comuna: new FormControl({ value: '' }, [Validators.required]),
      nombre: new FormControl({ value: '' }, [Validators.required, Validators.minLength(5), Validators.maxLength(100)]),
      direccion: new FormControl({ value: '' }),
      direccNueva: new FormControl({ value: '' }),
      usaDireccionDespacho: new FormControl({ value: true }),
      direccionDespacho: new FormControl({ value: '' }),
      contacto: new FormControl({ value: '' }, []),
      localidad: new FormControl({ value: '' }),
      fijo: new FormControl({ value: '' }),
      territorio: new FormControl({ value: '' }, [Validators.required]),
      movil: new FormControl({ value: '' }),
      ruta: new FormControl({ value: '' }, [Validators.required]),
      email: new FormControl({ value: '' }, [Validators.email]),
      showEmpresaHeredada: new FormControl({ value: true }),
      latitud: new FormControl({ value: '' }, [Validators.required]),
      longitud: new FormControl({ value: '' }, [Validators.required]),
      referencias: new FormControl('', [Validators.maxLength(160)]),
      facturarACasaMatriz: new FormControl({ value: this.RB_CASAMATRIZ_ }),
      direccionFormateada: new FormControl({ value: '' }),
      VendedorSel: new FormControl({ value: '' }),
      RubroSel: new FormControl({ value: '' }),
      secuencia: new FormControl({ value: 0 }),
      EmpresaAlteSel: new FormControl({ value: '' }),
    });
  }

  /********************************************************************/

  resetFormAgregar() {
    this.log('resetFormAgregar');
    this.formDatosPersonales.reset();
    this.formValidatorsService.reset(this.formDatosDirecciones);
    this.formDatosComerciales.reset();
    this.formDatosFinancieros.reset();
    this.formDatosPersonales.setAddDefaults();
    this.setDireccionesDefaults();
  }

  setDireccionesDefaults() {
    this.formDatosDirecciones.get('estadoDireccion').setValue(true);
  }

  showModalCargaMasiva() {
    this.cargaMasiva.show('CLIENTE');
  }

  showModalAgregar() {
    this.resetFormAgregar();
    this.staticTabs.setActiveTab(1);
    const self = this;
    const codigoOperacion = 7;
    this.listaClienteVendedorRubroIPT = [];
    this.listaClienteVendedorRubroIPTFixed = [];
    this.listaIPTVendedorClienteAgrega = [];
    this.listaVendedorRubroClienteAgrega = [];

    const inputParams = {
      rut_usu: self.rutUsuario,
      codgo_modulo: self.codigoModulo,
      cod_operacion: codigoOperacion,
    };

    this.clientesService.rolOperacionPermitida(inputParams, ({ mensajes, respuesta }) => {
      if (mensajes[0].tipo === TipoMensaje.SUCCESS) {
        // self.formAgregaDatosPersonales.reset();
        // self.formDatosDirecciones.reset();
        self.formDatosDirecciones.get('RubroSel').setValue(1); // Set rubro HELADOS, por defecto
        self.formDatosDirecciones.get('esCasaMatriz').setValue(true);
        self.formDatosDirecciones.get('usaDireccionDespacho').setValue(true);

        if (this.optionsEmpresaAlterna.length < 1) {
          this.HidenEmpresaHeredada = false;
          self.formDatosDirecciones.get('showEmpresaHeredada').setValue(false);
          this.formDatosDirecciones.get('EmpresaAlteSel').setValue(null);
        } else {
          this.HidenEmpresaHeredada = true;
          self.formDatosDirecciones.get('showEmpresaHeredada').setValue(true);
        }

        self.manejadorDireccionDespacho(false);
        self.formDatosComerciales.reset();
        self.formDatosFinancieros.reset();
        self.agregarModal.show();
      } else {
        // alert(notificacion.mensajes[0].texto);
        self.messageRendererService.showErrors(mensajes);
      }
    });
  }

  showModalDetalleCliente(cliente: cliente_proveedor) {
    this.modalResumen.loadAndShow(cliente);
  }

  showModalModificarDtoPersonales(cliente: cliente_proveedor) {
    this.editarModalDtoPersonales.loadAndShow(cliente);
  }

  showModalModificarDtoDireccion(cliente: cliente_proveedor) {
    this.modalEditarDirecciones.showModalModificarDtoDireccion(cliente);
  }

  showModalModificarDtoComerciales(cliente: cliente_proveedor) {
    this.modalDatosComerciales.loadAndShow(cliente);
  }

  showModalModificarDtoFinancieros(cliente: cliente_proveedor) {
    this.modalDatosFinancieros.loadAndShow(cliente);
  }

  validarYAgregar() {
    this.validarExistenciaCliente((valido) => {
      this.log('valido', valido);
      if (valido) {
        this.validaExisteClienteProveedorParaAgregar();
      }
    });
  }

  validarExistenciaCliente(callback: (valido: boolean) => void) {
    const { rutCliente } = this.formDatosPersonales.getFormData();
    const rut = this.rutService.QuitarDV(this.rutService.Limpiar(rutCliente));
    this.queryValidaExistenciaUsuario(rut.toString(), ({ registros }) => {
      const matches = registros.filter((cliente) => cliente.rut === rut);
      if (matches.length > 0) {
        const rutClienteFormateado = this.validadores._enmascaraRut(rut.toString());
        this.toastService.error(`El rut ${rutClienteFormateado} ya existe`, 'Atención');
        callback(false);
        return;
      }

      let valid = true;

      console.log('muestrame this.EmpresaHeredada ', this.optionsEmpresaAlterna.length);

      const formDatosFinancierosValid = this.formDatosFinancieros.validate();
      if (!formDatosFinancierosValid) {
        this.toastService.error('Complete datos financieros');
        valid = false;
      }

      const formDatosComercialesValid = this.formDatosComerciales.validate();
      if (!formDatosComercialesValid) {
        this.toastService.error('Complete datos comerciales');
        valid = false;
      }

      this.validateAllFormFields(this.formDatosDirecciones);
      if (!this.formDatosDirecciones.valid) {
        this.toastService.error('Complete datos direcciones');
        valid = false;
      }

      const formDatosPersonalesValid = this.formDatosPersonales.validate();
      if (!formDatosPersonalesValid) {
        this.toastService.error('Complete datos personales');
        valid = false;
      }

      callback(valid);
    });
  }

  validaExisteClienteProveedorParaAgregar() {
    const self = this; // this is unused
    const rut: number = Number(this.validadores._desenmascaraRutyQuitaDV(this.formDatosPersonales.getRutCliente()));

    const inputParams = {
      rutEmpresa: this.rutEmpresa,
      rutCliente: rut,
    };

    this.clientesService.ObtenerClienteProveedorSegunId(inputParams, ({ mensajes, respuesta }) => {
      const cte: cliente_proveedor = respuesta;
      if (cte != null) {
        // alert(
        //   'El cliente con el rut indicado existe y está asociado al cliente ' +
        //   cte.nombre +
        //   '. Acción cancelada.'
        // );
        self.toastService.warning('El cliente con el rut indicado existe y está asociado al cliente ' + cte.nombre + '. Acción cancelada.');
      } else {
        self.insertarDatosPersonales();
      }
    });
  }

  insertarDatosPersonales() {
    const formDatosPersonales = this.formDatosPersonales.getFormData();
    const formDatosFinancieros = this.formDatosFinancieros.getFormData();
    const formDatosComerciales = this.formDatosComerciales.getFormData();

    this.itemCliente = {
      rut: Number(this.validadores._desenmascaraRutyQuitaDV(formDatosPersonales.rutCliente)),
      nombre: formDatosComerciales.nombreFantasia,
      activo: formDatosPersonales.estadoCliente,
      bloqueado: formDatosPersonales.esClienteBloqueado,
      tipo_cliente_codigo: formDatosPersonales.tipoCliente,
      razon_social: formDatosPersonales.nombreCliente,
      empresa_rut: this.rutEmpresa,
      afecto_reglas_comerciales: Boolean(formDatosFinancieros.clieneAfectoReglasComerciales),
      descuento_maximo: Number(formDatosFinancieros.descuentoMaximo),
      es_cliente: true,
      es_proveedor: false,
      fax: '',
      fecha_actualizacion: new Date(),
      fecha_registro: new Date(),
      lista_precio_codigo: Number(formDatosFinancieros.listaPrecios),
      mail_intercambio: formDatosComerciales.emailIntercambio,
      mail_pdf: formDatosComerciales.emailEnvioPdf,
      mail_contacto: formDatosComerciales.emailContacto,
      observaciones: '',
      rut_usuario_actualiza: this.rutUsuario,
      rut_usuario_creacion: this.rutUsuario,
      telefono_principal: '',
      telefono_secundario: '',
      tipo_cobro_codigo: Number(formDatosFinancieros.tipoCobro),
      codigoModulo: this.codigoModulo,
      limite_credito: Number(formDatosFinancieros.limiteCredito),
      giro: formDatosComerciales.giroComercial,
    };

    if (this.formDatosDirecciones.get('latitud').value === null || this.formDatosDirecciones.get('latitud').value === undefined || this.formDatosDirecciones.get('latitud').value === 'null') {
      this.formDatosDirecciones.get('latitud').setValue('');
      return;
    }
    if (this.formDatosDirecciones.get('longitud').value === null || this.formDatosDirecciones.get('longitud').value === undefined || this.formDatosDirecciones.get('longitud').value === 'null') {
      this.formDatosDirecciones.get('longitud').setValue('');
      return;
    }

    if (!this.formDatosDirecciones.get('latitud').valid || !this.formDatosDirecciones.get('longitud').valid) {
      return;
    }
    if (this.formDatosDirecciones.get('secuencia').value === '') {
      this.formDatosDirecciones.get('secuencia').setValue('0');
    }
    let tieneCobrador = false;
    this.listaIPTVendedorClienteAgrega = [];
    this.listaVendedorRubroClienteAgrega = [];
    if (this.listaClienteVendedorRubroIPT === null) {
      // alert(
      //   'Debe seleccionar algún vendedor y rubro para este cliente/dirección'
      // );
      this.toastService.warning('Debe seleccionar algún vendedor y rubro para este cliente/dirección');
      this.staticTabs.setActiveTab(2);
      // this.showModalAgregarDireccion();
      return false;
    }
    // NO ES OBLIGATORIO GUARDAR EL VENDEDOR - Inicio Se comenta codigo
    if (this.listaClienteVendedorRubroIPT.length === 0) {
      this.toastService.warning('Debe seleccionar algún vendedor y rubro para este cliente/dirección');
      this.staticTabs.setActiveTab(2);
      return false;
    }
    // NO ES OBLIGATORIO GUARDAR EL VENDEDOR - Fin comentario

    for (let i = 0; i < this.listaClienteVendedorRubroIPT.length; i++) {
      // this.listaClienteVendedorRubroIPT.forEach((element) => {
      if (
        !this.listaClienteVendedorRubroIPT[i].lunes &&
        !this.listaClienteVendedorRubroIPT[i].martes &&
        !this.listaClienteVendedorRubroIPT[i].miercoles &&
        !this.listaClienteVendedorRubroIPT[i].jueves &&
        !this.listaClienteVendedorRubroIPT[i].viernes &&
        !this.listaClienteVendedorRubroIPT[i].sabado &&
        !this.listaClienteVendedorRubroIPT[i].domingo
      ) {
        // alert(
        //   'El IPT del vendedor ' + this.listaClienteVendedorRubroIPT[i].nombreVendedor + ' no está asignado'
        // );
        this.toastService.warning('El IPT del vendedor ' + this.listaClienteVendedorRubroIPT[i].nombreVendedor + ' no está asignado');
        this.staticTabs.setActiveTab(2);
        //this.showModalAgregarDireccion();
        return false;
      }
      // if (element.es_cobrador) {
      //   tieneCobrador = true;
      // }
    }
    // );

    const cobradoresMatches = this.listaClienteVendedorRubroIPT.filter((vendedor) => vendedor.es_cobrador).length;
    tieneCobrador = cobradoresMatches > 0;
    if (!tieneCobrador) {
      // alert('No se ha asignado ningún vendedor como cobrador.');
      this.toastService.warning('No se ha asignado ningún vendedor como cobrador.');
      // this.showModalAgregarDireccion(); // TODO: Why?????
      this.staticTabs.setActiveTab(2);
      return false;
    }

    const selectEmp = this.formDatosDirecciones.get('EmpresaAlteSel').value;
    const ShowEmp = this.formDatosDirecciones.get('showEmpresaHeredada').value;

    if (ShowEmp == true && selectEmp == null) {
      this.toastService.warning('No se ha asignado ninguna empresa destino.');
      this.staticTabs.setActiveTab(2);
      return false;
    }

    this.listaClienteVendedorRubroIPT.forEach((element) => {
      let itemvrc: vendedor_rubro_cliente;
      let itemiptvc: ipt_vendedor_cliente;
      itemvrc = {
        rubro_codigo: element.rubro_codigo,
        cliente_proveedor_rut: this.itemCliente.rut,
        direccion_codigo: element.direccion_codigo,
        realiza_cobro_maquina: element.realiza_cobro_maquina,
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa,
        vendedor_codigo: element.vendedor_codigo,
      };
      this.listaVendedorRubroClienteAgrega.push(itemvrc);
      itemiptvc = {
        cliente_proveedor_rut: this.itemCliente.rut,
        direccion_codigo: element.direccion_codigo,
        lunes: element.lunes,
        martes: element.martes,
        miercoles: element.miercoles,
        jueves: element.jueves,
        viernes: element.viernes,
        sabado: element.sabado,
        domingo: element.domingo,
        empresa_rut: this.rutEmpresa,
        es_cobrador: element.es_cobrador,
        fecha_actualizacion: new Date(),
        fecha_registro: new Date(),
        vendedor_codigo: element.vendedor_codigo,
        listaUnidadNegocio: element.unidad_negocio_codigo,
      };
      this.listaIPTVendedorClienteAgrega.push(itemiptvc);
    });

    this.itemDireccion = {
      activo: this.formDatosDirecciones.get('estadoDireccion').value,
      es_direccion_despacho: this.formDatosDirecciones.get('direccDesp').value,
      cliente_proveedor_rut: this.itemCliente.rut,
      codigo: this.direccionCliente,
      codigo_direccion_despacho: this.formDatosDirecciones.get('direccionDespacho').value,
      comuna_codigo: this.formDatosDirecciones.get('comuna').value,
      direccion_completa: this.ShowLongLat == false ? this.formDatosDirecciones.get('direccion').value : this.formDatosDirecciones.get('direccNueva').value,
      email_contacto: this.formDatosDirecciones.get('email').value,
      empresa_rut: this.rutEmpresa,
      es_principal: this.formDatosDirecciones.get('esCasaMatriz').value,
      facturar_a_casa_matriz: this.formDatosDirecciones.get('facturarACasaMatriz').value,
      fecha_creacion: new Date(),
      fono_fijo: this.formDatosDirecciones.get('fijo').value,
      fono_movil: this.formDatosDirecciones.get('movil').value,
      latitud: String(this.formDatosDirecciones.get('latitud').value),
      longitud: String(this.formDatosDirecciones.get('longitud').value),
      secuencia: this.formDatosDirecciones.get('secuencia').value,
      empresa_alterna_savory_idempalt: this.formDatosDirecciones.get('EmpresaAlteSel').value,
      localidad: this.formDatosDirecciones.get('localidad').value,
      nombre: this.formDatosDirecciones.get('nombre').value,
      nombre_contacto: this.formDatosDirecciones.get('contacto').value,
      referencias: this.formDatosDirecciones.get('referencias').value,
      ruta_codigo: this.formDatosDirecciones.get('ruta').value,
      territorio_codigo: this.formDatosDirecciones.get('territorio').value,
      usa_direccion_despacho: this.formDatosDirecciones.get('usaDireccionDespacho').value,
      condicion_pago_codigo: Number(formDatosFinancieros.condicionPago),
      rut_usuario: this.rutUsuario,
      codigoModulo: this.codigoModulo,
      moduloGrabacion: 1,
    };

    // this.log('itemCliente', this.itemCliente) // TODO: ONLY FOR DEV PURPOSES
    // return

    this.postClienteDatosPersonalesAgrega(this.itemCliente, this.itemDireccion, this.listaIPTVendedorClienteAgrega, this.listaVendedorRubroClienteAgrega);
  }

  obtenerDatosRegion() {
    const self = this; // this is unused

    this.clientesService.ObtenerAllRegion(({ mensajes, respuesta }) => {
      const { registros } = respuesta;
      self.listaRegiones = registros;
      self.optionsRegion = [];
      let sel: any;
      self.listaRegiones.forEach((element) => {
        sel = { value: element.codigo, label: element.nombre };
        self.optionsRegion.push(sel);
      });
    });
  }

  loadComboRubros() {
    const self = this; // this is unused

    const inputParams = {
      rutEmpresa: this.rutEmpresa,
    };

    this.clientesService.ObtenerRubrosCliente(inputParams, ({ mensajes, respuesta }) => {
      const { registros } = respuesta;
      self.listaRubros = registros;
      self.optionsRubro = [];
      let sel: any;
      self.listaRubros.forEach((element) => {
        sel = { value: element.codigo, label: element.descripcion };
        self.optionsRubro.push(sel);
      });
    });
  }

  loadEmpesaAlterna() {
    const inputParams = {
      codigo_comuna: this.comunaCodigo,
      paginaActual: 1,
      cantidadRegistrosPorPagina: 1,
    };

    this.empresaAlternaSavoryService.obtenerSegunFiltro(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      const { registros } = respuesta;
      this.optionsEmpresaAlterna = registros.map((emp) => ({ value: emp.idempalt, label: emp.detalle, ...emp }));
      this.formValidatorsService.selectFirstOrDefault(this.formDatosDirecciones.get('EmpresaAlteSel'), this.optionsEmpresaAlterna);
    });
  }

  obtenerDatosRuta() {
    const self = this; // this is unused

    const inputParams = {
      rutEmpresa: this.rutEmpresa,
      sucursalEmpresa: this.sucursalEmpresa,
    };

    this.clientesService.DatosRutaSegunFiltro(inputParams, ({ mensajes, respuesta }) => {
      const { registros } = respuesta;

      self.listaRutasDireccion = registros;
      self.optionsRutaDireccion = [];
      let sel: any;
      self.listaRutasDireccion.forEach((element) => {
        sel = { value: element.codigo, label: element.descripcion };
        self.optionsRutaDireccion.push(sel);
      });
    });
  }

  obtenerDatosTerritorio() {
    const self = this; // this is unused

    const inputParams = {
      rutEmpresa: this.rutEmpresa,
      sucursalEmpresa: this.sucursalEmpresa,
    };

    this.clientesService.ObtenerTerritorioSegunFiltro(inputParams, ({ mensajes, respuesta }) => {
      const { registros } = respuesta;
      self.listaTerritoriosDireccion = registros;
      self.optionsTerritorioDireccion = [];
      let sel: any;
      self.listaTerritoriosDireccion.forEach((element) => {
        sel = { value: element.codigo, label: element.nombre };
        self.optionsTerritorioDireccion.push(sel);
      });
    });
  }

  obtenerDatosVendedores() {
    const self = this; // this is unused
    // const regionSeleccionada = this.formDatosDirecciones.get('region')
    //   .value;

    this.client.query(
      {
        query: gql`
          query ($rutEmpresa: Decimal, $sucursalCodigo: Decimal) {
            vendedor {
              obtenerSegunFiltro(filtro: { exacto: { rut_empresa: $rutEmpresa, sucursal_codigo: $sucursalCodigo, tipobusqueda: 1 } }) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  registros {
                    codigo
                    nombre
                  }
                }
              }
            }
          }
        `,
        variables: {
          rutEmpresa: this.rutEmpresa,
          sucursalCodigo: this.sucursalEmpresa,
        },
        fetchPolicy: 'no-cache',
      },
      function (respuesta) {
        self.listaVendedor = respuesta.data.vendedor.obtenerSegunFiltro.respuesta.registros;
        self.optionsVendedor = [];
        let sel: any;
        self.listaVendedor.forEach((element) => {
          sel = { value: element.codigo, label: element.nombre };
          self.optionsVendedor.push(sel);
        });
      }
    );
  }

  obtenerDatosComunas() {
    const self = this; // this is unused

    this.client.query(
      {
        query: gql`
          query {
            comuna {
              obtenerSegunFiltro(filtro: { exacto: { codigo: -1, provincia_codigo: -1, nombre: "", codigo_region: -1 } }) {
                respuesta {
                  registros {
                    codigo
                    nombre
                    provincia_codigo
                  }
                }
              }
            }
          }
        `,
        fetchPolicy: 'no-cache',
      },
      function (respuesta) {
        self.listaComunasFiltro = respuesta.data.comuna.obtenerSegunFiltro.respuesta.registros;
        self.optionsFiltroComuna = [];
        self.optionsDatosDireccionAgregarComuna = [];
        let sel: any;
        self.listaComunasFiltro.forEach((element) => {
          sel = { value: element.codigo, label: element.nombre };
          self.optionsFiltroComuna.push(sel);
          self.optionsDatosDireccionAgregarComuna.push(sel);
        });
      }
    );
  }

  obtenerCanales() {
    console.log('obtenerCanales');
    const self = this; // this is unused
    this.client.query(
      {
        query: gql`
          query {
            canal {
              obtenerTodos {
                respuesta {
                  registros {
                    idcanal
                    descripcion
                  }
                }
              }
            }
          }
        `,
        fetchPolicy: 'no-cache',
      },
      function (respuesta) {
        self.listaCanales = respuesta.data.canal.obtenerTodos.respuesta.registros;
        self.optionsCanal = self.listaCanales.map((x: canal) => ({ value: x.idcanal, label: x.descripcion }));
      }
    )
  }

  obtenerDatosTipoCliente() {
    const self = this; // this is unused

    this.client.query(
      {
        query: gql`
          query {
            tipo_cliente {
              obtenerTodos {
                respuesta {
                  registros {
                    codigo
                    descripcion
                    idcanal
                  }
                }
              }
            }
          }
        `,
        fetchPolicy: 'no-cache',
      },
      function (respuesta) {
        self.listaTipoClientes = respuesta.data.tipo_cliente.obtenerTodos.respuesta.registros;
        self.optionsTipoCliente = self.listaTipoClientes;
        // let sel: any;
        // self.listaTipoClientes.forEach((element) => {
        //   sel = { value: element.codigo, label: element.descripcion };
        //   self.optionsTipoCliente.push(sel);
        // });
      }
    );
  }

  obtenerDatosModalFinancieros() {
    const self = this;

    this.client.query(
      {
        query: gql`
          query ($rutEmpresa: Decimal, $sucursalCodigo: Decimal, $sucursalEmpresa: Decimal) {
            condicion_pago {
              obtenerSegunFiltro(filtro: { exacto: { rut_empresa: $rutEmpresa, sucursal_codigo: $sucursalCodigo, tipobusqueda: 1 } }) {
                respuesta {
                  registros {
                    codigo
                    descripcion
                  }
                }
              }
            }

            lista_precio {
              obtenerSegunFiltro(filtro: { exacto: { rut_empresa: $rutEmpresa, sucursal_codigo: $sucursalEmpresa, codigo: -1 } }) {
                respuesta {
                  registros {
                    codigo
                  }
                }
              }
            }
          }
        `,
        variables: {
          rutEmpresa: this.rutEmpresa,
          sucursalCodigo: this.sucursalEmpresa,
          sucursalEmpresa: this.sucursalEmpresa,
        },
        fetchPolicy: 'no-cache',
      },
      function (respuesta) {
        // const { registros: listaTipoCobro } = respuesta.data.tipo_cobro.obtenerTodos.respuesta;
        // self.optionsTipoCobro = listaTipoCobro.map(p => ({ value: p.codigo, label: p.descripcion }))
        // self.log('self.optionsTipoCobro', self.optionsTipoCobro)

        const { registros: listaCondicionDePago } = respuesta.data.condicion_pago.obtenerSegunFiltro.respuesta; //.registros.filter(p => p.estado);
        self.optionsCondicionPago = listaCondicionDePago.map((p) => ({ value: p.codigo, label: p.descripcion }));

        const { registros: listaPrecios } = respuesta.data.lista_precio.obtenerSegunFiltro.respuesta; //.registros.filter(p => p.estado);
        self.optionsListaPrecios = listaPrecios.map((p) => ({ value: p.codigo, label: p.codigo }));
      }
    );
  }

  limpiarfiltros() {
    this.log(this.formBuscaDatosGrillaPrincipal.value);
    this.formBuscaDatosGrillaPrincipal.reset();
    this.formBuscaDatosGrillaPrincipal.get('filtroPrincipalRutCliente').setValue('');
    this.formBuscaDatosGrillaPrincipal.get('filtroPrincipalNombreCliente').setValue('');
    this.formBuscaDatosGrillaPrincipal.get('filtroPrincipalDireccionCliente').setValue('');
    this.formBuscaDatosGrillaPrincipal.get('filtroPrincipalComuna').setValue({ value: '' });
    this.formBuscaDatosGrillaPrincipal.get('filtroPrincipalEstadoBloqueo').setValue(false);
    this.formBuscaDatosGrillaPrincipal.get('filtroPrincipalxEstado').setValue(true);
    this.formBuscaDatosGrillaPrincipal.get('filtroPrincipalVendedor').setValue('');
    this.listaCliente = null;
    this.HighlightRow = null;

    this.filtraGrillaVistaPrincipal();
  }

  filtraExcelVistaPrincipal() {
    const self = this; // this is unused
    this.obtenerParametrosFiltroGrillaPrincipal();

    this.client.query(
      {
        query: gql`
          query (
            $rutEmpresa: Decimal
            $rutCliente: Decimal
            $nombreCliente: String
            $direccionCompleta: String
            $codigoComuna: Int
            $busquedaxEstado: Int
            $esBloqueado: Boolean
            $paginaActual: Int
            $vendedorSel: [Decimal]
          ) {
            cliente_proveedor {
              obtenerSegunFiltroConExcel(
                filtro: {
                  exacto: {
                    rut: $rutCliente
                    nombre: $nombreCliente
                    direccion_completa: $direccionCompleta
                    codigo_comuna: $codigoComuna
                    busquedaxEstado: $busquedaxEstado
                    bloqueado: $esBloqueado
                    empresa_rut: $rutEmpresa
                    retornaExcel: true
                    es_cliente: true
                    vendedorSel: $vendedorSel
                  }
                }
                paginaActual: $paginaActual
                cantidadRegistrosPorPagina: 10
              ) {
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
        fetchPolicy: 'no-cache',
        variables: {
          rutEmpresa: this.rutEmpresa,
          rutCliente: this.filtroPrincipalRutCliente,
          nombreCliente: this.filtroPrincipalNombreCliente,
          direccionCompleta: this.filtroPrincipalDireccionCliente,
          codigoComuna: this.filtroPrincipalComuna,
          busquedaxEstado: this.filtroxEstado,
          esBloqueado: this.filtroPrincipalEstadoBloqueo,
          paginaActual: this.paginaActual,
          vendedorSel: this.filtroPrincipalVendedor,
        },
      },
      function (respuesta) {
        if (respuesta.data.cliente_proveedor.obtenerSegunFiltroConExcel.respuesta != null) {
          if (respuesta.data.cliente_proveedor.obtenerSegunFiltroConExcel.respuesta.registros[0].rutaArchivo !== '') {
            document.location.href = XLS_URL + '//' + respuesta.data.cliente_proveedor.obtenerSegunFiltroConExcel.respuesta.registros[0].rutaArchivo;
          }
        } else {
          // alert(
          //   'Lo sentimos, ha ocurrido un error al obtener los datos solicitados. Consulte a Soporte ISSTEC Ltda.'
          // );
          self.toastService.error('Lo sentimos, ha ocurrido un error al obtener los datos solicitados. Consulte a Soporte ISSTEC Ltda.');
        }
      }
    );
  }

  cambiaNombre() {
    alert('caca');
  }

  loadComboDirecciones() {
    const self = this; // this is unused

    this.client.query(
      {
        query: gql`
          query ($rutEmpresa: Decimal, $rutCliente: Decimal) {
            direccion {
              obtenerSegunFiltro(filtro: { exacto: { cliente_proveedor_rut: $rutCliente, empresa_rut: $rutEmpresa, direccion_completa: "", nombre: "", activo: true } }) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    nombre
                  }
                }
              }
            }
          }
        `,
        fetchPolicy: 'no-cache',
        variables: {
          rutEmpresa: this.rutEmpresa,
          rutCliente: this.rutCliente,
        },
      },
      function (respuesta) {
        self.listaDireccionesCombo = respuesta.data.direccion.obtenerSegunFiltro.respuesta.registros;
        self.optionsDireccion = [];
        let sel: any;
        if (self.listaDireccionesCombo.length > 0) {
          self.listaDireccionesCombo.forEach((element) => {
            sel = { value: element.codigo, label: element.nombre };
            self.optionsDireccion.push(sel);
          });
        } else {
          sel = { value: -1, label: '' };
          self.optionsDireccion.push(sel);
        }
      }
    );
  }

  filtraGrillaDirecciones() {
    const self = this; // this is unused

    this.filtroDireccionNombre = this.filtroDireccionNombre === undefined ? '' : this.filtroDireccionNombre;
    this.filtroDireccionDireccion = this.filtroDireccionDireccion === undefined ? '' : this.filtroDireccionDireccion;

    this.client.query(
      {
        query: gql`
          query ($rutEmpresa: Decimal, $rutCliente: Decimal, $nombreDireccion: String, $direccionCompleta: String, $paginaActual: Int) {
            direccion {
              obtenerSegunFiltro(
                filtro: { exacto: { cliente_proveedor_rut: $rutCliente, empresa_rut: $rutEmpresa, direccion_completa: $direccionCompleta, nombre: $nombreDireccion } }
                paginaActual: $paginaActual
                cantidadRegistrosPorPagina: 10
              ) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    cliente_proveedor_rut
                    codigo
                    direccion_completa
                    comuna_codigo
                    es_principal
                    territorio_codigo
                    ruta_codigo
                    empresa_rut
                    fecha_creacion
                    nombre
                    nombre_contacto
                    codigo_direccion_despacho
                    usa_direccion_despacho
                    localidad
                    fono_fijo
                    fono_movil
                    email_contacto
                    latitud
                    longitud
                    referencias
                    facturar_a_casa_matriz
                    activo
                  }
                }
              }
            }
          }
        `,
        fetchPolicy: 'no-cache',
        variables: {
          rutEmpresa: this.rutEmpresa,
          rutCliente: this.rutCliente,
          nombreDireccion: this.filtroDireccionNombre,
          direccionCompleta: this.filtroPrincipalDireccionCliente,
          paginaActual: this.paginaActualDirecciones,
        },
      },
      function (respuesta) {
        self.listaDirecciones = respuesta.data.direccion.obtenerSegunFiltro.respuesta.registros;
        self.totalRegistrosDirecciones = respuesta.data.direccion.obtenerSegunFiltro.respuesta.totalRegistros;
        self.totalPaginasDirecciones = respuesta.data.direccion.obtenerSegunFiltro.respuesta.totalPaginas;
        if (self.totalPaginasDirecciones === 0) {
          self.totalPaginasDirecciones = 1;
        }
      }
    );
  }
  obtenerParametrosFiltroGrillaPrincipal() {
    this.filtroPrincipalRutCliente = this.validadores._desenmascaraRutyQuitaDV(this.formBuscaDatosGrillaPrincipal.get('filtroPrincipalRutCliente').value);
    this.filtroPrincipalNombreCliente = this.formBuscaDatosGrillaPrincipal.get('filtroPrincipalNombreCliente').value;
    this.filtroPrincipalDireccionCliente = this.formBuscaDatosGrillaPrincipal.get('filtroPrincipalDireccionCliente').value;
    this.filtroPrincipalComuna = this.formBuscaDatosGrillaPrincipal.get('filtroPrincipalComuna').value;
    this.filtroPrincipalEstadoBloqueo = this.formBuscaDatosGrillaPrincipal.get('filtroPrincipalEstadoBloqueo').value;
    this.filtroPrincipalEstado = this.formBuscaDatosGrillaPrincipal.get('filtroPrincipalxEstado').value;
    this.filtroPrincipalVendedor = this.formBuscaDatosGrillaPrincipal.get('filtroPrincipalVendedor').value;

    this.log('filtroPrincipalVendedor', this.filtroPrincipalVendedor);

    if (this.filtroPrincipalVendedor == '') {
      this.filtroPrincipalVendedor = [];
      // this.optionsVendedor.forEach((element) => {
      //   this.filtroPrincipalVendedor.push(element.value);
      // });
    }

    if (this.filtroPrincipalComuna['value'] === '') {
      this.filtroPrincipalComuna = '-1';
    }

    this.filtroPrincipalRutCliente = this.filtroPrincipalRutCliente === '' ? '0' : this.filtroPrincipalRutCliente;

    this.filtroPrincipalRutCliente = this.filtroPrincipalRutCliente === undefined ? '0' : this.filtroPrincipalRutCliente;
    this.filtroPrincipalNombreCliente = this.filtroPrincipalNombreCliente === undefined ? '' : this.filtroPrincipalNombreCliente;
    this.filtroPrincipalDireccionCliente = this.filtroPrincipalDireccionCliente === undefined ? '' : this.filtroPrincipalDireccionCliente;
    this.filtroPrincipalComuna = this.filtroPrincipalComuna === '' ? '-1' : this.filtroPrincipalComuna;
    this.filtroPrincipalComuna = this.filtroPrincipalComuna === undefined ? '-1' : this.filtroPrincipalComuna;
    this.filtroPrincipalEstadoBloqueo = this.filtroPrincipalEstadoBloqueo === undefined ? false : this.filtroPrincipalEstadoBloqueo;

    this.filtroxEstado = this.filtroPrincipalEstado ? 1 : 2;

    const _variables: any = {
      rutEmpresa: this.rutEmpresa,
      rutCliente: this.filtroPrincipalRutCliente,
      nombreCliente: this.filtroPrincipalNombreCliente,
      direccionCompleta: this.filtroPrincipalDireccionCliente,
      codigoComuna: this.filtroPrincipalComuna,
      busquedaxEstado: this.filtroxEstado,
      esBloqueado: this.filtroPrincipalEstadoBloqueo,
      paginaActual: this.paginaActual,
    };
  }

  filtraGrillaVistaPrincipal() {
    this.obtenerParametrosFiltroGrillaPrincipal();
    const self = this; // this is unused

    this.loading = true;
    this.listOfCliente = [];
    this.log(
      'variables',
      JSON.stringify({
        rutEmpresa: this.rutEmpresa,
        rutCliente: this.filtroPrincipalRutCliente,
        nombreCliente: this.filtroPrincipalNombreCliente,
        direccionCompleta: this.filtroPrincipalDireccionCliente,
        codigoComuna: this.filtroPrincipalComuna,
        busquedaxEstado: this.filtroxEstado,
        esBloqueado: this.filtroPrincipalEstadoBloqueo,
        paginaActual: this.paginaActual,
        vendedorSel: this.filtroPrincipalVendedor,
      })
    );

    const inputParams = {
      rutEmpresa: this.rutEmpresa,
      rutCliente: this.filtroPrincipalRutCliente,
      nombreCliente: this.filtroPrincipalNombreCliente,
      direccionCompleta: this.filtroPrincipalDireccionCliente,
      codigoComuna: this.filtroPrincipalComuna,
      busquedaxEstado: this.filtroxEstado,
      esBloqueado: this.filtroPrincipalEstadoBloqueo,
      paginaActual: this.paginaActual,
      vendedorSel: this.filtroPrincipalVendedor,
      cantidadRegistrosPorPagina: 20,
    };

    this.currentPayLoad = _.cloneDeep(inputParams);

    this.spinner.show();

    this.clientesService.GetClientesFiltro(inputParams);

    this.clientesService.queryCliente.subscribe((data: any[]) => {
      this.PagPosActual = data[0].obtenerSegunFiltroMaestraCliente.respuesta.paginaActual;
      this.totalPagPos = data[0].obtenerSegunFiltroMaestraCliente.respuesta.totalPaginas;
      this.totalRegistrosPos = data[0].obtenerSegunFiltroMaestraCliente.respuesta.totalRegistros;
      this.listOfCliente = data[0].obtenerSegunFiltroMaestraCliente.respuesta.registros.slice(0, 20);
      // console.log(this.listOfCliente);
      this.spinner.hide();
      if (data[0].obtenerSegunFiltroMaestraCliente.respuesta.paginaActual === data[0].obtenerSegunFiltroMaestraCliente.respuesta.totalPaginas) {
        self.document.getElementById('spinnerX').style.display = 'none';
      }
    });

    this.notscrolly = true;
    this.notEmptyPost = true;

    this.PageNum = 1;
  }

  mascaraRut(evento) {
    this.validadores._mascaraRut(evento);
  }

  onOpenEditProveedor(rutProveedor: string) {
    this.agregarModal.hide();
    this.modalEditarProveedor.loadAndShow(rutProveedor);
  }

  postClienteDatosPersonalesAgrega(
    clienteIngresado: cliente_proveedor,
    direccionIngresada: direccion,
    listaIPTVendedorCliente: ipt_vendedor_cliente[],
    listaVendedorRubroCliente: vendedor_rubro_cliente[]
  ) {
    const self = this;
    const bodyx = clienteIngresado;

    listaVendedorRubroCliente.forEach(function (item) {
      item.direccion_codigo = self.direccionCliente;
    });
    listaIPTVendedorCliente.forEach(function (item) {
      item.direccion_codigo = self.direccionCliente;
      item.codigo_modulo = self.codigoModulo;
      item.rut_usuario = self.rutUsuario;
    });

    this.log(
      'mutation, cliente_proveedor.agregarClienteCompleto',
      JSON.stringify({
        entidadCliente: bodyx,
        entidadDireccion: direccionIngresada,
        entidadIPTVendedor: { obj: listaIPTVendedorCliente },
        entidadVendedorRubro: { obj: listaVendedorRubroCliente },
      })
    );
    this.client.mutate(
      {
        mutation: gql`
          mutation (
            $entidadCliente: cliente_proveedorInputType
            $entidadDireccion: direccionInputType
            $entidadIPTVendedor: ipt_vendedor_clienteListaInputType
            $entidadVendedorRubro: vendedor_rubro_clienteListaInputType
          ) {
            cliente_proveedor {
              agregarClienteCompleto(entidadCliente: $entidadCliente, entidadDireccion: $entidadDireccion, entidadIPTVendedor: $entidadIPTVendedor, entidadVendedorRubro: $entidadVendedorRubro) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  rut
                  nombre
                }
              }
            }
          }
        `,
        variables: {
          entidadCliente: bodyx,
          entidadDireccion: direccionIngresada,
          entidadIPTVendedor: { obj: listaIPTVendedorCliente },
          entidadVendedorRubro: { obj: listaVendedorRubroCliente },
        },
      },
      function (respuesta) {
        if (respuesta.data.cliente_proveedor.agregarClienteCompleto.respuesta != null) {
          // alert("Registro grabado");
          self.toastService.success('Registro grabado');
          self.agregarModal.hide();
          setTimeout(() => self.filtraGrillaVistaPrincipal(), 1000);
        } else {
          // alert(respuesta.data.cliente_proveedor.agregarClienteCompleto.mensajes[0].texto);
          self.messageRendererService.showErrors(respuesta.data.cliente_proveedor.agregarClienteCompleto.mensajes);
          // alert(respuesta.data.cliente_proveedor.agregarClienteCompleto.mensajes[0].texto);
          // self.messageRendererService.showErrors(respuesta.data.cliente_proveedor.agregarClienteCompleto.mensajes)
        }
      }
    );
  }

  manejadorDireccionDespacho(edita: boolean) {
    // if (edita) {
    //   if (Boolean(this.formEditaDatosDirecciones.get('usaDireccionDespacho').value)) {
    //     this.formEditaDatosDirecciones.get('direccionDespacho').reset();
    //     this.formEditaDatosDirecciones.get('direccionDespacho').disable();
    //     if (this.direccionCliente !== -1) {
    //       this.formEditaDatosDirecciones.get('direccionDespacho').setValue(this.direccionCliente);
    //     }
    //     this.formEditaDatosDirecciones.get('direccionDespacho').setValidators([]);
    //   }
    //   else {
    //     if (this.listaDireccionesCombo.length <= 0) {
    //       // alert('No hay direcciones disponibles para seleccionar. Debe escoger esta misma dirección como dirección de despacho');
    //       this.toastService.warning('No hay direcciones disponibles para seleccionar. Debe escoger esta misma dirección como dirección de despacho');
    //       this.formEditaDatosDirecciones.get('usaDireccionDespacho').setValue(true);
    //     }
    //     else {
    //       this.formEditaDatosDirecciones.get('direccionDespacho').enable();

    //       this.formEditaDatosDirecciones.get('direccionDespacho').reset();
    //       this.formEditaDatosDirecciones.get('direccionDespacho').setValidators([Validators.required]);
    //     }

    //   }
    // }
    // else
    {
      if (Boolean(this.formDatosDirecciones.get('usaDireccionDespacho').value)) {
        this.formDatosDirecciones.get('direccionDespacho').reset();
        this.formDatosDirecciones.get('direccionDespacho').disable();
        if (this.direccionCliente !== -1) {
          this.formDatosDirecciones.get('direccionDespacho').setValue(this.direccionCliente);
        }
        this.formDatosDirecciones.get('direccionDespacho').setValidators([]);
      } else {
        if (this.listaDirecciones === undefined) {
          this.listaDireccionesCombo = [];
        }
        if (this.listaDireccionesCombo.length <= 0) {
          // alert('No hay direcciones disponibles para seleccionar. Debe escoger esta misma dirección como dirección de despacho');
          this.toastService.warning('No hay direcciones disponibles para seleccionar. Debe escoger esta misma dirección como dirección de despacho');
          this.formDatosDirecciones.get('usaDireccionDespacho').setValue(true);
        } else {
          this.formDatosDirecciones.get('direccionDespacho').enable();

          this.formDatosDirecciones.get('direccionDespacho').reset();
          this.formDatosDirecciones.get('direccionDespacho').setValidators([Validators.required]);
        }
      }
    }
  }

  retrocedePaginaGrillaVistaPrincipal() {
    this.paginaActual = this.paginaActual - 1;
    this.filtraGrillaVistaPrincipal();
  }

  avanzaPaginaGrillaVistaPrincipal() {
    this.paginaActual = this.paginaActual + 1;
    this.filtraGrillaVistaPrincipal();
  }

  /********* MODAL DATOS COMERCIALES *********/

  /********* MODAL DATOS COMERCIALES *********/

  /********* MODAL DATOS FINANCIEROS *********/

  /********* MODAL DATOS FINANCIEROS *********/

  /********* MODAL RESUMEN *********/
  detalleClientePrint() {
    window.print();
    // this.resumenModal.hide();
  }
  /********* MODAL RESUMEN *********/

  validateAllFormFields(formGroup: FormGroup) {
    // {1}
    Object.keys(formGroup.controls).forEach((field) => {
      // {2}
      const control = formGroup.get(field); // {3}
      if (control instanceof FormControl) {
        // {4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        // {5}
        this.validateAllFormFields(control); // {6}
      }
    });
  }

  setNombreDireccion(nombre: string) {
    this.formDatosDirecciones.get('nombre').setValue(nombre);
  }

  onNombreDatosPersonalesChange(nombre: string) {
    this.setNombreDireccion(nombre);
    this.formDatosComerciales.setNombreFantasia(nombre);
  }

  verRubros(rubroipt, i) {
    const vendedorRubrosVisiblesIndex = this.getVendedorRubrosVisiblesIndex();
    const vendedorSeleccionadoIndex = this.listaClienteVendedorRubroIPTFixed.findIndex((vendedor: cliente_vendedor_rubro_IPTFixed) => vendedor.vendedor_codigo === rubroipt.vendedor_codigo);
    this.hideAllRubrosPanel();

    if (vendedorRubrosVisiblesIndex !== vendedorSeleccionadoIndex) this.listaClienteVendedorRubroIPTFixed[vendedorSeleccionadoIndex].rubrosVisibles = true;
  }

  getVendedorRubrosVisiblesIndex() {
    return this.listaClienteVendedorRubroIPTFixed ? this.listaClienteVendedorRubroIPTFixed.findIndex((vendedor: cliente_vendedor_rubro_IPTFixed) => vendedor.rubrosVisibles) : -1;
  }

  hideAllRubrosPanel() {
    this.listaClienteVendedorRubroIPTFixed.forEach((vendedor: cliente_vendedor_rubro_IPTFixed) => {
      vendedor.rubrosVisibles = false;
    });
  }

  // eliminaRubroAssigned(rubroipt: cliente_vendedor_rubro_IPTFixed, rubroEliminado: any) {
  //   this.listaClienteVendedorRubroIPT = this.listaClienteVendedorRubroIPT.filter(vendedor => !(vendedor.vendedor_codigo === rubroipt.vendedor_codigo && vendedor.rubro_codigo === rubroEliminado.rubro_codigo))
  //   this.setListaVendedoresFixed()
  // }

  async UpdateTablaPrincipal() {
    const self = this;
    const a = await new Promise((resolve) => {
      // Simulamos una operación asincrónica con setTimeout
      setTimeout(() => {
        this.filtraGrillaVistaPrincipal();
      }, 1000);
    });

    return await Promise.resolve(a);
  }

  parametroUnidadNegocio() {
    this.parametroEmpresaService.permiteUnidadNegocio(this.rutEmpresa, ({ respuesta, mensajes }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      this.permiteUnidadNegocio = respuesta.valor_bool;
    });
  }
  loadUnidadNegocio() {
    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        tipo: 1,
      },
    };
    this.optionsUnidadesDeNegocio = [];
    this.unidadNegocioService.obtenerUnidadNegocio(inputParams, ({ respuesta }) => {
      const { registros } = respuesta;
      this.optionsUnidadesDeNegocio = registros.map((unidad_negocio) => ({
        value: unidad_negocio.codigo,
        label: unidad_negocio.nombre,
      }));
    });
  }
  canCargaClienteMasivo() {
    const input: any = {
      rut_usu: this.accesolocalstorage.getRutUsuario(),
      cod_operacion: 17,
      codgo_modulo: 1,
    }
    this.canAddClientesMasivos = false;
    this.rolOperacion.operacionPermitida(input, (response: boolean) => {
      this.canAddClientesMasivos = response;
    });
  }
}
